import { logger } from '@sentry/react';
import CanvasSession from '../services/CanvasSession';
import { Command } from './Command';

export class CommandManager {
  private session: CanvasSession;
  private stack: Command[] = [];
  private redoStack: Command[] = [];

  constructor(session: CanvasSession) {
    this.session = session;
  }

  executeCommand(command: Command): void {
    if (!command.isEphemeral) {
      this.stack.push(command);
    }
    this.redoStack = [];
    const changes = command.execute();
    this.session.addLocalChange(changes);
  }

  getUpdatedVersion(id: string) {
    const userVersion = this.session.getElementVersion(id);

    if (!userVersion) {
      logger.error('Element version not found', {
        elementId: id,
      });
      return {
        userId: 'unknown',
        version: 1,
      };
    }

    return {
      ...userVersion,
      version: userVersion.version + 1,
    };
  }

  undo() {
    const command = this.stack.pop();
    if (!command) return;

    const changes = command.undo();
    this.redoStack.push(command);

    const updatedChanges = changes.map((change) => {
      const userVersion = this.getUpdatedVersion(change.object.id);
      return {
        ...change,
        object: {
          ...change.object,
          userVersion,
        },
      };
    });

    this.session.addLocalChange(updatedChanges);
  }

  redo() {
    const command = this.redoStack.pop();

    if (!command) return;

    this.stack.push(command);
    const changes = command.execute();

    const updatedChanges = changes.map((change) => {
      const userVersion = this.getUpdatedVersion(change.object.id);
      return {
        ...change,
        object: {
          ...change.object,
          userVersion,
        },
      };
    });

    this.session.addLocalChange(updatedChanges);
  }

  canUndo() {
    return this.stack.length > 0;
  }

  canRedo() {
    return this.redoStack.length > 0;
  }
}
